import { render, staticRenderFns } from "./TheMainNavbar.vue?vue&type=template&id=52840e8a&"
import script from "./TheMainNavbar.vue?vue&type=script&lang=js&"
export * from "./TheMainNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TheMainNavbar.vue?vue&type=style&index=0&id=52840e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports